import type { FlowProcess } from '@/features/flow/Flow';

export const renewalSteps = {
  RENEW_INSURANCE: 'renew-insurance',
  PAYMENT_FAILED: 'payment-failed',
  WRONG_LINK_RENEWAL_PAGE: 'wrong-link-renewal-page',
  WRONG_LINK_CONTACT_US: 'wrong-link-contact-us',
  ALREADY_RENEWED: 'already-renewed',
  CANT_RENEW: 'cant-renew',
  PAYMENT_LINK_AVAILABLE: 'payment-link-available',
  POLICY_RENEWED: 'policy-renewed',
};

export const renewalmentOrder: FlowProcess[] = [
  {
    name: renewalSteps.RENEW_INSURANCE,
  },
  {
    name: renewalSteps.PAYMENT_FAILED,
  },
  {
    name: renewalSteps.WRONG_LINK_RENEWAL_PAGE,
  },
  {
    name: renewalSteps.WRONG_LINK_CONTACT_US,
  },
  {
    name: renewalSteps.ALREADY_RENEWED,
  },
  {
    name: renewalSteps.CANT_RENEW,
  },
  {
    name: renewalSteps.PAYMENT_LINK_AVAILABLE,
  },
];
